module.exports = __webpack_public_path__ + "img/code_dy.3aaf211b.png";